var _g, _g2, _g3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLockRed = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#c50d0d",
    width: "115px",
    height: "115px",
    viewBox: "-0.32 -0.32 32.64 32.64",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.000,32.000 L3.000,32.000 C1.346,32.000 0.000,30.654 0.000,29.000 L0.000,14.000 C0.000,12.346 1.346,11.000 3.000,11.000 L5.000,11.000 L5.000,8.000 C5.000,3.589 8.589,-0.000 13.000,-0.000 C17.411,-0.000 21.000,3.589 21.000,8.000 L21.000,11.000 L23.000,11.000 C24.654,11.000 26.000,12.346 26.000,14.000 L26.000,29.000 C26.000,30.654 24.654,32.000 23.000,32.000 ZM19.000,8.000 C19.000,4.691 16.309,2.000 13.000,2.000 C9.691,2.000 7.000,4.691 7.000,8.000 L7.000,11.000 L19.000,11.000 L19.000,8.000 ZM24.000,14.000 C24.000,13.448 23.552,13.000 23.000,13.000 L3.000,13.000 C2.448,13.000 2.000,13.448 2.000,14.000 L2.000,29.000 C2.000,29.552 2.448,30.000 3.000,30.000 L23.000,30.000 C23.552,30.000 24.000,29.552 24.000,29.000 L24.000,14.000 ZM14.000,20.722 L14.000,24.000 C14.000,24.553 13.553,25.000 13.000,25.000 C12.447,25.000 12.000,24.553 12.000,24.000 L12.000,20.722 C11.405,20.375 11.000,19.737 11.000,19.000 C11.000,17.898 11.897,17.000 13.000,17.000 C14.102,17.000 15.000,17.898 15.000,19.000 C15.000,19.737 14.595,20.375 14.000,20.722 Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLockRed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lockRed.ba256341.svg";
export { ForwardRef as ReactComponent };